
import * as __star__ from 'dom-align';

const {
default: __default__,
alignElement,
alignPoint,
__esModule
} = __star__;

export {
alignElement,
alignPoint,
__esModule
};
export default __default__;
